import { SeatDto, TableState } from '@/services/table/tableState';
import { TablesSeatsPreview } from '@/services/friends/friendsServicesTypes';

export const formatValue = (num: string | number) => {
  if (typeof num === 'number') {
    return num.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }
  return num;
};

export function adaptTableStateToPreview(tablesState: TableState[]): TablesSeatsPreview[] {
  return tablesState.map((tableState) => ({
    table: {
      id: tableState.tableId,
      game: tableState.game,
      name: tableState.name,
      maxPlayers: tableState.maxPlayers,
      seats: tableState.seats.filter((seat): seat is SeatDto => seat !== null),
    },
  }));
}
